import { useFormik } from "formik";
import { Button, Col, Row, Form, Collapse } from "react-bootstrap";
import { toast } from "sonner";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { baseURL } from "../../services/axios/eps";
import { createSection, updateSection } from "../../services/axios/apiManager";
import { SwitchButtonMedium } from "../../Components/switchButton";
import {
  formatDateForInput,
  getTodayDateString,
  getNextWeekDateString,
} from "../../services/dataManager";

const PromotionForm = ({
  id,
  selectedOption,
  navigate,
  gamesList,
  sectionData,
}) => {
  const [loading, setLoading] = useState(false);
  const [gamesQuery, setGamesQuery] = useState("");
  const [timed, setTimed] = useState(0);
  const [selectedGames, setSelectedGames] = useState([]);

  const formik = useFormik({
    initialValues: {
      heading: sectionData.heading || "",
      details: sectionData?.details || "",
      status: sectionData?.status || 1,
      image: sectionData.image || null,
      games_included: sectionData?.games_included || 1,
      games_list: sectionData?.games_list || "",
      section_type: sectionData?.section_type || "",
      layout_style: sectionData?.layout_style || "carousel",
      is_timed: sectionData?.is_timed || 0,
      items_per_row: sectionData?.items_per_row || 4,
      section_key: sectionData?.section_key || "",
      start_date:
        formatDateForInput(sectionData?.start_date) || getTodayDateString(),
      end_date:
        formatDateForInput(sectionData?.end_date) || getNextWeekDateString(),
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      heading: Yup.string().required("Heading is required"),
      start_date: Yup.date()
        .nullable()
        .when("is_timed", {
          is: (val) => val === 1 || val === true,
          then: () =>
            Yup.date()
              .required("Start date is required")
              // .min(
              //   new Date(new Date().setHours(0, 0, 0, 0)),
              //   "Start date cannot be in the past",
              // )
              .nullable(),
          otherwise: () => Yup.date().nullable(),
        }),
      end_date: Yup.date()
        .nullable()
        .when("is_timed", {
          is: (val) => val === 1 || val === true,
          then: () =>
            Yup.date()
              .required("End date is required")
              .min(
                Yup.ref("start_date"),
                "End date cannot be before start date",
              )
              .nullable(),
          otherwise: () => Yup.date().nullable(),
        }),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const payload = {
          ...values,
          section_type: selectedOption,
        };
        console.log("payload :", payload);
        let res;
        if (id) {
          res = await updateSection({ id, ...payload });
        } else {
          res = await createSection(payload);
        }
        if (res?.data?.success) {
          toast.success(res?.data?.message || "Section saved successfully");
          navigate("/home-page");
        } else {
          toast.error(res?.data?.message || "Failed to save section");
        }
      } catch (err) {
        console.error(err);
        toast.error("An error occurred while saving");
      } finally {
        setLoading(false);
      }
    },
  });
  const handleAddGame = (id) => {
    let temp = [];
    if (selectedGames?.includes(id)) {
      temp = selectedGames.filter((item) => item !== id);
      setSelectedGames(temp);
      formik.setFieldValue("games_list", temp);
    } else {
      temp = [...selectedGames, id];
      setSelectedGames(temp);
      formik.setFieldValue("games_list", temp);
    }
  };

  const handleSwitchBtn = () => {
    if (timed === 1) {
      setTimed(0);
      formik.setFieldValue("is_timed", 0);
    } else {
      setTimed(1);
      formik.setFieldValue("is_timed", 1);
    }
  };
  const filteredGames =
    gamesList?.filter((game) => {
      if (!gamesQuery) return true;
      const gameTitle = game?.title?.toLowerCase() || "";
      const searchQuery = gamesQuery.toLowerCase();
      return gameTitle.includes(searchQuery);
    }) || [];

  useEffect(() => {
    if (formik.submitCount > 0 && Object.keys(formik.errors).length > 0) {
      window.scroll({ top: 0, behavior: "smooth" });
    }
  }, [formik.submitCount, formik.errors]);

  useEffect(() => {
    if (sectionData) {
      setSelectedGames(sectionData?.games_list || []);
      setTimed(sectionData?.is_timed === 1 ? 1 : 0);
    }
  }, [sectionData]);

  return (
    <div className="align-items-center mt-5 p-4 rounded w-100 bg-dark">
      <Form onSubmit={formik.handleSubmit}>
        <Row className="mb-4">
          <Col xs={12} md={6}>
            <Form.Label>Heading</Form.Label>
            <Form.Control
              type="text"
              data-testid="heading"
              className="bg-dark text-light border-light input-placeholder-light py-4"
              placeholder="Enter Heading"
              {...formik.getFieldProps("heading")}
              isInvalid={formik.touched.heading && !!formik.errors.heading}
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.heading}
            </Form.Control.Feedback>
          </Col>
          <Col xs={12} md={6}>
            <Form.Label>Sub-Heading</Form.Label>
            <Form.Control
              type="text"
              data-testid="sub-heading"
              className="bg-dark text-light border-light input-placeholder-light py-4"
              placeholder="Enter Sub-Heading"
              {...formik.getFieldProps("sub_heading")}
              isInvalid={
                formik.touched.sub_heading && !!formik.errors.sub_heading
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.sub_heading}
            </Form.Control.Feedback>
          </Col>
        </Row>

        {selectedOption === "game_list" ? (
          <Row className="mb-4">
            <Col xs={12} md={6}>
              <Form.Label>Layout Style</Form.Label>
              <Form.Select
                data-testid="layout-style"
                className="bg-dark text-light border-light input-placeholder-light"
                style={{ paddingTop: "9px", paddingBottom: "9px" }}
                {...formik.getFieldProps("layout_style")}
                isInvalid={
                  formik.touched.layout_style && !!formik.errors.layout
                }
              >
                <option value="grid">Grid</option>
                {/* <option value="carousel">Carousel</option> */}
                {/* <option value="list">List</option> */}
                <option value="masonry">Masonry</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {formik.errors.layout_style}
              </Form.Control.Feedback>
            </Col>
            <Col xs={12} md={6}>
              <Form.Label>Items Per Row</Form.Label>
              <Form.Control
                type="number"
                data-testid="items-per-row"
                className="bg-dark text-light border-light input-placeholder-light py-4"
                {...formik.getFieldProps("items_per_row")}
                isInvalid={
                  formik.touched.items_per_row && !!formik.errors.items_per_row
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.items_per_row}
              </Form.Control.Feedback>
            </Col>
          </Row>
        ) : null}
        <div className="container-fluid py-2 px-0 mb-3">
          <div className="d-flex align-items-center">
            <Form.Label className="mb-0 mx-2 text-light font-semibold">
              Timed Section
            </Form.Label>
            <SwitchButtonMedium
              isOn={formik.values.is_timed === 1}
              color={"#00af43ff"}
              onClick={() => {
                handleSwitchBtn();
              }}
            />
            <span
              className={`mx-3 text-sm font-medium ${formik.values.is_timed === 1 ? "text-success" : "text-muted"}`}
              style={{ fontSize: "0.9rem" }}
            >
              {formik.values.is_timed === 1
                ? "Yes (Active during specified dates)"
                : "No (Always Active)"}
            </span>
          </div>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateRows: timed === 1 ? "1fr" : "0fr",
            transition: "grid-template-rows 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              minHeight: "0px",
              transition: "opacity 0.3s ease-in-out, padding 0.35s ease-in-out",
              opacity: timed === 1 ? 1 : 0,
              paddingBottom: timed === 1 ? "1.5rem" : "0px",
            }}
          >
            <Row className="mb-4">
              <Col xs={12} md={6}>
                <Form.Label>Start Date</Form.Label>
                <Form.Control
                  type="date"
                  data-testid="start-date"
                  className="text-light border-light bg-dark py-4 input-placeholder-light"
                  {...formik.getFieldProps("start_date")}
                  isInvalid={
                    formik.touched.start_date && !!formik.errors.start_date
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.start_date}
                </Form.Control.Feedback>
              </Col>
              <Col xs={12} md={6}>
                <Form.Label>End Date</Form.Label>
                <Form.Control
                  type="date"
                  data-testid="end-date"
                  className="bg-dark text-light border-light input-placeholder-light py-4"
                  {...formik.getFieldProps("end_date")}
                  isInvalid={
                    formik.touched.end_date && !!formik.errors.end_date
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.end_date}
                </Form.Control.Feedback>
              </Col>
            </Row>
          </div>
        </div>
        <hr />
        <div>
          <p className="text-light font-bold">{`Select Games (${selectedGames?.length || 0} Selected)`}</p>
          <Form.Control
            data-testid="game-search"
            className="bg-dark text-light input-placeholder-light border-light py-4 mb-3"
            placeholder="Search games..."
            value={gamesQuery}
            onChange={(e) => {
              setGamesQuery(e.target.value);
            }}
          />

          <div className="flex bg-dark rounded py-4">
            <div
              className="row w-100 overflow-auto"
              style={{ minHeight: "100px", maxHeight: "600px" }}
            >
              {filteredGames?.length ? (
                filteredGames?.map((item) => (
                  <div
                    key={item.id}
                    className="col-sm-12 col-md-4"
                    onClick={() => {
                      handleAddGame(item.id);
                    }}
                  >
                    <div
                      className={`d-flex justify-content-between align-items-center p-2 m-2 rounded-lg cursor-pointer ${selectedGames?.includes(item.id) ? "border-2 border-indigo-600 bg-slate-800" : "border-2 bg-dark"}`}
                    >
                      <div className="d-flex align-items-center">
                        <img
                          crossOrigin="anonymous"
                          src={`${baseURL}/uploads/file/${item?.icon}`}
                          alt="game icon"
                          style={{
                            maxHeight: "60px",
                            minHeight: "60px",
                            width: "60px",
                            borderRadius: "10px",
                            objectFit: "contain",
                          }}
                        />
                        <span className="mx-2">{item.title}</span>
                      </div>
                      {selectedGames?.includes(item.id) && (
                        <div className="text-indigo-600 dark:text-indigo-400">
                          <svg
                            className="w-5 h-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <span>No games</span>
              )}
            </div>
          </div>
        </div>
        <hr />
        <div className="d-flex justify-content-end mt-4 gap-2">
          <Button
            variant="secondary"
            onClick={() => navigate("/home-page")}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button variant="success" type="submit" disabled={loading}>
            {loading ? "Saving..." : id ? "Save Changes" : "Create Section"}
          </Button>
        </div>
      </Form>
    </div>
  );
};
export default PromotionForm;
